'use client';

import { c as _c } from "react/compiler-runtime";
import { useParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useEventListener } from 'usehooks-ts';
import { useLayoutContext } from '@/context/LayoutContext';
import { useUAContext } from '@/context/UAContext';
export function useActiveSection(sectionIds) {
  const $ = _c(9);
  const [activeId, setActiveId] = useState(null);
  const {
    headerHeight
  } = useLayoutContext();
  const {
    isMobile
  } = useUAContext();
  const {
    identifier
  } = useParams();
  let t0;
  if ($[0] !== activeId || $[1] !== headerHeight || $[2] !== identifier || $[3] !== isMobile || $[4] !== sectionIds) {
    t0 = () => {
      isMobile ? identifier ? 120 : 120 : 120;
      const scrollPosition = window.scrollY + headerHeight + 120;
      const firstSectionId = sectionIds[0];
      let closestSectionId = null;
      let firstSectionOutOfView = false;
      sectionIds.forEach(id => {
        const section = document.getElementById(id);
        if (section) {
          const sectionTop = section.offsetTop;
          const sectionBottom = sectionTop + section.offsetHeight;
          if (scrollPosition >= sectionTop - 1 && scrollPosition < sectionBottom) {
            closestSectionId = id;
          }
          if (id === firstSectionId && scrollPosition < sectionTop) {
            firstSectionOutOfView = true;
          }
        }
      });
      if (firstSectionOutOfView && activeId === firstSectionId) {
        setActiveId(null);
      }
      if (closestSectionId && closestSectionId !== activeId) {
        setActiveId(closestSectionId);
      }
    };
    $[0] = activeId;
    $[1] = headerHeight;
    $[2] = identifier;
    $[3] = isMobile;
    $[4] = sectionIds;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const onScroll = t0;
  useEventListener("scroll", onScroll);
  let t1;
  if ($[6] !== onScroll) {
    t1 = () => {
      onScroll();
    };
    $[6] = onScroll;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  return activeId;
}